// extracted by mini-css-extract-plugin
module.exports = {"container":"Connect-panel_container__3UeVO"};